import { render, staticRenderFns } from "./data-alter.vue?vue&type=template&id=d115a316&scoped=true"
import script from "./data-alter.vue?vue&type=script&lang=js"
export * from "./data-alter.vue?vue&type=script&lang=js"
import style0 from "./data-alter.vue?vue&type=style&index=0&id=d115a316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d115a316",
  null
  
)

export default component.exports